export const TT_REQUIRED_MESSAGE = 'This field is required.';

export type TtFieldErrors = {
    appointmentTypeId?: string;
    otherAppointmentType?: string;
    translationAppointmentDate?: string;
    translationFrequencyAndDuration?: string;
    languageId?: string;
    otherLanguage?: string;
    transportationRequiredId?: string;
    otherTransportationRequired?: string;
    transportationAppointmentDate?: string;
    transportationFrequencyAndDuration?: string;
    originationId?: string;
    originationContactNumber?: string;
    destinationId?: string;
};

const FIELD_LABELS: Record<keyof TtFieldErrors, string> = {
    appointmentTypeId: 'Appointment Type',
    otherAppointmentType: 'Other Appointment Type',
    translationAppointmentDate: 'Translation Appointment Date',
    translationFrequencyAndDuration: 'Translation Frequency and Duration',
    languageId: 'Language',
    otherLanguage: 'Other Language',
    transportationRequiredId: 'Transportation Required',
    otherTransportationRequired: 'Other Transportation Required',
    transportationAppointmentDate: 'Transportation Appointment Date',
    transportationFrequencyAndDuration: 'Transportation Frequency and Duration',
    originationId: 'Origination',
    originationContactNumber: 'Origination Contact Number',
    destinationId: 'Destination',
};

export function validateTtFields(params: {
    showTranslation: boolean;
    showTransportation: boolean;
    translation?: {
        appointmentTypeId?: number;
        otherAppointmentType?: string;
        appointmentDate?: string | Date;
        frequencyAndDuration?: string;
        languageId?: number;
        otherLanguage?: string;
    };
    transportation?: {
        transportationRequiredId?: number;
        otherTransportationRequired?: string;
        appointmentDate?: string | Date;
        frequencyAndDuration?: string;
        originationId?: number;
        originationContactNumber?: string;
        destinationId?: number;
    };
}): TtFieldErrors {
    const errors: TtFieldErrors = {};

    if (params.showTranslation && params.translation) {
        const translation = params.translation;
        if ((translation.appointmentTypeId ?? -1) < 0) {
            errors.appointmentTypeId = TT_REQUIRED_MESSAGE;
        }
        if (translation.appointmentTypeId === 0 && !translation.otherAppointmentType?.trim()) {
            errors.otherAppointmentType = TT_REQUIRED_MESSAGE;
        }
        if (!translation.appointmentDate) {
            errors.translationAppointmentDate = TT_REQUIRED_MESSAGE;
        }
        if (!translation.frequencyAndDuration?.trim()) {
            errors.translationFrequencyAndDuration = TT_REQUIRED_MESSAGE;
        }
        if ((translation.languageId ?? -1) < 0) {
            errors.languageId = TT_REQUIRED_MESSAGE;
        }
        if (translation.languageId === 0 && !translation.otherLanguage?.trim()) {
            errors.otherLanguage = TT_REQUIRED_MESSAGE;
        }
    }

    if (params.showTransportation && params.transportation) {
        const transportation = params.transportation;
        if ((transportation.transportationRequiredId ?? -1) < 0) {
            errors.transportationRequiredId = TT_REQUIRED_MESSAGE;
        }
        if (transportation.transportationRequiredId === 0 && !transportation.otherTransportationRequired?.trim()) {
            errors.otherTransportationRequired = TT_REQUIRED_MESSAGE;
        }
        if (!transportation.appointmentDate) {
            errors.transportationAppointmentDate = TT_REQUIRED_MESSAGE;
        }
        if (!transportation.frequencyAndDuration?.trim()) {
            errors.transportationFrequencyAndDuration = TT_REQUIRED_MESSAGE;
        }
        if ((transportation.originationId ?? -1) < 0) {
            errors.originationId = TT_REQUIRED_MESSAGE;
        }
        if (!transportation.originationContactNumber?.trim()) {
            errors.originationContactNumber = TT_REQUIRED_MESSAGE;
        }
        if ((transportation.destinationId ?? -1) < 0) {
            errors.destinationId = TT_REQUIRED_MESSAGE;
        }
    }

    return errors;
}

export function isTtFormValid(errors: TtFieldErrors): boolean {
    return Object.keys(errors).length === 0;
}

export function getTtMissingFieldLabels(errors: TtFieldErrors): string[] {
    return (Object.keys(errors) as Array<keyof TtFieldErrors>).map((key) => FIELD_LABELS[key]);
}

export function getTtValidationToastMessage(errors: TtFieldErrors): string {
    const labels = getTtMissingFieldLabels(errors);
    if (labels.length === 0) {
        return '';
    }
    return `Please complete the following required fields: ${labels.join(', ')}.`;
}
